if ($(".type-detail").length) {

  shoptet.scripts.setCustomCallback('shoptet.products.replaceImage', function() {
    $('.p-image img').attr('src', $('.p-image a img').attr('src').replace('/big/', '/orig/'));
  });
  shoptet.scripts.setCustomCallback('shoptet.images.unveil', function() {
    $('.p-image img').attr('src', $('.p-image a img').attr('src').replace('/big/', '/orig/'));
  });

  
  if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
    $('.p-image-wrapper').addClass('haveThumbnails')
    $('.p-image-wrapper .p-image').append('<span class="customArrowsImage arrow-prev"></span><span class="customArrowsImage arrow-next"></span>');

    $('body').on('click', '.arrow-prev, .arrow-next', function () {
        var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
        var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
        var isNext = $(this).hasClass('arrow-next');
        var totalThumbnails = thumbnails.length;
        var currentIndex = thumbnails.index(highlightedThumbnail);

        // Odebrání třídy 'highlighted' u všech thumbnailů
        thumbnails.removeClass('highlighted');

        // Logika pro určení nového zvýrazněného thumbnailu
        if (highlightedThumbnail.length === 0) {
            highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
        } else {
            currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
            highlightedThumbnail = thumbnails.eq(currentIndex);
        }

        // Přidání třídy 'highlighted' k nově zvýrazněnému thumbnailu
        highlightedThumbnail.addClass('highlighted');

        // Kontrola pro .show360image a skrytí/zobrazení .image360 a .p-image
        toggle360ImageVisibility(highlightedThumbnail);

        // Aktualizace hlavního obrázku
        setTimeout(function () {
            updateMainImage(highlightedThumbnail);
            updateThumbnailCount(thumbnails);
        }, 10);
    });

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href').replace('/big/', '/orig/');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
    }

    function updateThumbnailCount(thumbnails) {
        var highlightedIndex = thumbnails.index($('.p-thumbnails-inner a.highlighted')) + 1;
        var totalThumbnails = thumbnails.length;
        $('.thumbCount .from').html(highlightedIndex);
        $('.thumbCount .to').html(totalThumbnails);
    }

    function toggle360ImageVisibility(highlightedThumbnail) {
        var is360Image = highlightedThumbnail.hasClass('show360image');

        if (is360Image) {
            // Pokud ano, zobrazit .image360 a skrýt .p-image
            $('.image360').show();
            $('.p-image').hide();
        } else {
            // Pokud ne, skrýt .image360 a zobrazit .p-image
            $('.image360').hide();
            $('.p-image').show();
        }
    }

    // Inicializace počtu thumbnailů
    updateThumbnailCount($('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image'));
  }





  $(".p-info-wrapper").append($(".p-detail-inner-header").clone());

  $(".p-info-wrapper").append($('.p-detail-info .flags.flags-default').clone().addClass('daysToBake'));
  $(".p-info-wrapper").append($('.p-detail-info .flags.flags-default').clone().addClass('otherFlags'));
  $(".p-info-wrapper .flags.daysToBake").prepend('<span>Kdy nabízíme?</span>');
  $('p[data-testid="productCardDescr"] a').text("Více informací");
 


  
 $(".extended-description .detail-parameters tr").each(function () {
  const $row = $(this);
  const $label = $row.find("th .row-header-label").first();
  const $value = $row.find("td").first();

  if (!$label.length) {
    return;
  }

  const text = $label
    .text()
    .replace(":", "")
    .trim();

  if (text === "Složení") {
    $row.addClass("hideIt");

    const $infoBlock = $('<div class="detail-info-block composition"></div>');

    $("<h3>", {
      text: "Složení"
    }).appendTo($infoBlock);

    $('<div class="detail-info-content"></div>')
      .append($value.contents().clone())
      .appendTo($infoBlock);

    $(".p-info-wrapper").append($infoBlock);
  }

  if (text === "Alergeny") {
    $row.addClass("hideIt");

    const $infoBlock = $('<div class="detail-info-block allergens"></div>');

    $("<h3>", {
      text: "Alergeny"
    }).appendTo($infoBlock);

    const $content = $('<div class="detail-info-content"></div>')
      .append($value.contents().clone());

    $('<div class="link"><a href="'+alergenyUrl+'" class="moreInfo" target="_blank">Více informací o alergenech</a></div>')
      .appendTo($content);

    $content.appendTo($infoBlock);

    $(".p-info-wrapper").append($infoBlock);
  }

  if (text === "Jaké dny se prodává") {
    $row.addClass("hideIt");
  }
});

  $(".basic-description h3").text("Popis");
  $(".extended-description h3").text("Parametry");
  if ($('.basic-description').length && $('.basic-description>p').first().text().trim() !== 'Popis produktu není dostupný') {
    $(".p-info-wrapper").append($(".basic-description").clone());
  }
  $(".p-info-wrapper").append($(".extended-description").clone());

  $(document).on("click", ".p-info-wrapper > div > h3", function () {
    const parent = $(this).closest(".p-info-wrapper > div");
    const isOpen = parent.hasClass("openIt");
    $(".p-info-wrapper > div").removeClass("openIt");
    if (!isOpen) {
      parent.addClass("openIt");
    }
  });

  $(".products-related-header").text("Produkty dostupné ve stejný den");








}
